export const getHtmlFormValue = <T = Record<string, unknown>>(formElement: HTMLFormElement) => {
  const formData = new FormData(formElement);
  const values = {} as T;
  for (const pair of formData.entries()) {
    values[pair[0]] = pair[1];
  }

  return values;
};